import { render, staticRenderFns } from "./project-detail-base.vue?vue&type=template&id=56baa758&scoped=true&"
import script from "./project-detail-base.vue?vue&type=script&lang=js&"
export * from "./project-detail-base.vue?vue&type=script&lang=js&"
import style0 from "./project-detail-base.vue?vue&type=style&index=0&id=56baa758&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56baa758",
  null
  
)

export default component.exports